/* eslint-disable @next/next/no-img-element */
// libraries
import { hifenUrl } from '../../../utils/hifenUrl';
import Slider from '@mui/material/Slider';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import Link from 'next/link';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { allCaracteristicas, allDatasEntrega, categorias, district, get_estados } from '../../../services/selectors';
import { ensureReadableTextColor, formatCaracteristicas, formatSelects, formatSelectsTransacao, isColorLight, removerAcentos, toPrice } from '../../../utils/FunctionsGlobals';
import { carregarEstadosComPais, cidadesDoPais, estadosDoPais, getEstadosComPaisStorageKey, listarPaises, paisDoEstado, PAIS_QUERY_PARAM, temFiltroPais } from '../../../utils/filtroPais';
import {
    getImoveisListCategoryStorageKey,
    getImoveisListCaracteristicasStorageKey,
    getImoveisListDatasStorageKey,
    getImoveisListStatesStorageKey,
    readJsonStorageValue,
} from '../../../utils/homeCache';
import { getWithTTL, setWithTTL } from '../../../utils/storage';
import { appendCodsiteQuery } from '../../../utils/url';
import { buscaCidadeFixaEstrita } from '../../../utils/condominiosBusca';
import { genMetaEventId, trackMetaEvent } from '../../../utils/metaPixel';
import { getHeroVideoPoster, useHeroVideoReady } from '../../../utils/heroVideo';
import { useCidadeFixaBusca } from '../../../utils/cidadeFixaBusca';
import { useAuth, useRegiaoHref } from '../../context/Info';
import { useCidadesMulti } from '../../shared/city-multi/useCidadesMulti';
import DrawerComponent from '../../drawer/DrawerComponent';
// framer-motion REAL (não o lightMotion estático): dá fade-in no topo/busca pra esconder
// a "renderização feia" (react-select ssr:false entram só na hidratação sobre a caixa colorida).
// Custo aceito pelo Daniel (24/06). framer-motion volta pro chunk da home (welcome é dynamic).
import { motion } from 'framer-motion';
import Mocks from './WelcomePieces.mocks';
import styles from './WelcomePieces.module.css';
import { condominioDependenteDe, useCondominiosDependentes } from '../../../utils/condominiosDependentes';
import { mostraLogoNoHero } from '../../../utils/logoNoHero';
import { fontesMaioresDoSite, tituloEmDuasLinhas } from '../../../utils/fontesMaioresPorSite';
import { usePreviaBuilder } from '../../../lib/previaBuilder';
const Select = dynamic(() => import('react-select'), { ssr: false });

// cs2587 (TEOMI, sugestão #56): "tem empreendimento que não é condomínio e sim loteamento".
// GATE por codsite — os demais ~300 sites seguem com "Condomínios".
const ROTULO_EMPREENDIMENTO_2587 = 'Condomínio/Empreendimento';

// interface
export interface ISelectors {
    allCities: Array<{ label: string; value: string; id_estado: any }>;
    allTypes: any;
    allTransacao: Array<{ label: string; value: string }>;
    allCompany: Array<{ label: string; value: string }>;
    site: any;
    urlBanner: string;
    companyInputActual: any;
    setCompanyInputActual: any;
    setActiveDrawer: any;
    activeDrawer: any;
    origin?: any;
    codsite?: any;
    favorito: Array<number>;
    valores?: any;
    codsite2?: any;
    isMobile1?: Boolean;
    props: any;
    allCards: any;
    /**
     * BUSCA POR IA (modelo_busca = 10): slot opcional renderizado no TOPO do cartão de
     * busca, acima dos filtros clássicos. Recebe a transação escolhida no select para a
     * frase livre respeitar Comprar/Alugar/Temporada. Sem a prop, nada muda no hero 1.
     */
    /** Slot da barra de IA (hero 10). `filtrosAbertos` = o visitante clicou em "Avançado" e os
     *  filtros clássicos estão visíveis — a barra usa isso pra mostrar o divisor "ou use os filtros". */
    aiSearch?: (_ctx: {
        transacao: string;
        filtrosAbertos: boolean;
        /** Toggle Comprar/Alugar/Temporada da barra de IA (hero 10) — muda a MESMA transação do
         *  select clássico (`transacaoActual`), pra "Avançado" e o Buscar clássico acompanharem. */
        onTransacaoChange: (_value: string) => void;
        /** Categoria fixada pela barra (opção "Lançamentos" do cs2619) — null quando o visitante
         *  está numa transação normal. Ver utils/buscaCategoriaFixa. */
        categoriaFixa: number | null;
        /** Liga/desliga a categoria fixa. O Buscar clássico passa a mandar `?categoria=<id>`. */
        onCategoriaFixaChange: (_id: number | null) => void;
    }) => React.ReactNode;
}

const WelcomePieces: React.FC<ISelectors> = ({
    allCities,
    allTypes,
    allCompany,
    allTransacao,
    site,
    urlBanner,
    companyInputActual,
    setCompanyInputActual,
    setActiveDrawer,
    activeDrawer,
    origin,
    codsite,
    favorito,
    valores,
    codsite2,
    isMobile1,
    props,
    allCards,
    aiSearch
}) => {
    const { videoParado } = usePreviaBuilder(); // prévia dos cards do CRM: vídeo parado na capa
    // Hero: pôster (leve) = LCP; vídeo (pesado) carrega só depois do LCP (só vídeos default).
    // Pôster: o do vídeo REGIONAL (quando o tenant enviou um) vence o derivado
    // dos vídeos default — vídeo custom sem pôster segue sem pôster, como hoje.
    const heroPoster = site?.url_video_poster || getHeroVideoPoster(site?.url_video);
    const heroVideoReady = useHeroVideoReady();
    // constants
    const {
        listCategory,
        setListCategory,
        listEstados,
        setListEstados,
        listCaracteristicas,
        setListCaracteristicas,
        listDatas,
        setListDatas
    } = useAuth();
    const colorPicker = Mocks.customSelectStyles(isColorLight(site?.cor12) ? site?.cor11 : site?.cor13);
    const searchButtonBackground = site?.cor2 || '#1e1e1e';
    const searchButtonPreferredTextColor = isColorLight(site?.cor2) ? site?.cor11 : site?.cor13;
    const searchButtonTextColor = ensureReadableTextColor(searchButtonPreferredTextColor, searchButtonBackground);
    const isSite2507 = Number(site?.id) === 2507;
    const isSite2523 = Number(site?.id) === 2523;
    // cs2644 (15/10): título (H1) e subtítulo (H2) do topo também no celular — o padrão esconde abaixo de 850px.
    const isSite2644 = Number(site?.id) === 2644;
    const fontesMaiores = fontesMaioresDoSite(site);
    const isSite2587 = Number(site?.id) === 2587;
    // cs2452: Condominio na barra principal da busca, fora da avancada
    const isSite2452 = Number(site?.id) === 2452;
    // cs2551 (Hachbart): o cliente pediu DIGITAR o preco em vez de arrastar a barra —
    // os dois rotulos de preco viram campos editaveis; o Slider continua funcionando.
    const isSite2551 = Number(site?.id) === 2551;
    // #1140 cs2618 (Femar): site de um único empreendimento — a busca da home fica só com o
    // essencial. Cidade, Transação e Tipo saem da tela; Dormitórios/Preço seguem no avançado.
    const isSite2618 = Number(site?.id) === 2618;
    // Com 3 campos a menos, os que sobram na linha (Bairro e Código) dividem a largura —
    // sem isso a linha ficaria com metade vazia à direita.
    const searchFieldStyle2618 = isSite2618 ? { width: '50%' } : {};
    const showHomeCategoria = Boolean(site?.categoria_home) && !isSite2507;
    const showHomeCaracteristicas = Boolean(site?.caracteristicas_home) && !isSite2507;
    const showHomeDormitorios = true;
    const primarySearchFieldsCount2507 = site?.transacoes?.length > 1 ? 4 : 3;
    const primarySearchGap2507 = 12;
    const primarySearchFieldStyle2507 = isSite2507
        ? { width: `calc((100% - ${(primarySearchFieldsCount2507 - 1) * primarySearchGap2507}px) / ${primarySearchFieldsCount2507})` }
        : {};
    const hasDataEntrega2507 = Boolean(site?.mostrar_data_entrega && listDatas?.length > 0);
    const advancedFieldStyle2507 = primarySearchFieldStyle2507;
    const advancedFirstFieldStyle2507 = isSite2507 && primarySearchFieldsCount2507 === 4 && !hasDataEntrega2507
        ? {
            ...primarySearchFieldStyle2507,
            marginLeft: `calc((100% - ${(primarySearchFieldsCount2507 - 1) * primarySearchGap2507}px) / ${primarySearchFieldsCount2507} + ${primarySearchGap2507}px)`
        }
        : primarySearchFieldStyle2507;
    function valuetext(value: number) {
        return `${value}°C`;
    }
    const allOptions = [{label: '1', value: 1},{label: '2', value: 2},{label: '3', value: 3},{label: '4', value: 4},{label: '5 +', value: 5}];
    const [allDistrict, setAllDistrict] = useState([]);
    const cidadesBaseBusca = useMemo(
        () => (site?.id == 2065 ? allCities.filter((city: any) => city?.id_estado == 24) : site?.id == 2297 || site?.id == 1942 ? allCities.filter((city: any) => city?.id_estado == 23) : allCities),
        [allCities, site?.id]
    );
    const [allCitiesAux, setAllCitiesAux] = useState(cidadesBaseBusca);
    // MULTI-FILIAIS: `allCities` muda quando o visitante troca de filial — o
    // estado local (que só nasce na 1ª montagem) precisa acompanhar. Sem região
    // a referência é estável ⇒ setState com o MESMO valor, sem re-render.
    useEffect(() => {
        setAllCitiesAux(cidadesBaseBusca);
    }, [cidadesBaseBusca]);
    const [searchAdvanced, setSearchAdvanced] = useState(site?.id == "1667" || site?.id == "2366" || site?.id == "2118" || site?.id == "278" || isSite2618 ? 1 : 0);
    const shouldHideHeaderText = Boolean(searchAdvanced && !isSite2523);
    const [citiesActual, setCitiesActual] = useState<any>(null);
    const [districtActual, setDistrictActual] = useState<Array<{label: string, value: number}>>([]);
    const [typesActual, setTypesActual] = useState<Array<{label: string, value: number}>>([]);
    const [caractActual, setCaractActual] = useState<Array<{label: string, value: number}>>([]);
    const [dataEntregaActual, setDataEntregaActual] = useState<Array<{label: string, value: number}>>([]);
    const [categoryActual, setCategoryActual] = useState<any>([]);
    const [estadoActual, setEstadoActual] = useState<any>(site?.id == 2065 ? {label: 'Santa Catarina', value: 24} : site?.id == 2297 || site?.id == 1942 ? {label: 'Rio Grande do Sul', value: 23} : {value: 0});
    // cs2065: País e Estado em dois selects (utils/filtroPais). O País nasce em Brasil porque o
    // Estado desta licença nasce em Santa Catarina (linha acima).
    const filtroPais = temFiltroPais(site?.id);
    const [paisActual, setPaisActual] = useState<any>(filtroPais ? { label: 'Brasil', value: 'brasil' } : null);
    const listPaises = useMemo(() => (filtroPais ? listarPaises(listEstados) : []), [filtroPais, listEstados]);
    const estadosVisiveis = useMemo(
        () => (filtroPais && paisActual?.value ? estadosDoPais(listEstados, paisActual.value) : listEstados),
        [filtroPais, listEstados, paisActual?.value]
    );
    const [urlTipo, setUrlTipo] = useState<string>("");
    const [urlCaract, setUrlCaract] = useState<string>("");
    const [urlDatas, setUrlDatas] = useState<string>("");
    const [urlDistrict, setUrlDistrict] = useState<string>("");
    const [transacaoActual, setTransacaoActual] = useState<any>(
    site?.id == 2470 || Number(site?.id) === 2523 ? null : allTransacao[0]
);
    // Categoria fixada pela barra de IA (hero 10, opção "Lançamentos" do cs2619). Quando ligada,
    // o Buscar clássico manda `?categoria=<id>` junto com os filtros avançados — o formato que a
    // listagem já usa. null = comportamento de sempre (o dos ~300 sites).
    const [categoriaFixa, setCategoriaFixa] = useState<number | null>(null);
    const [dormitoriosActual, setDormitoriosAtual] = useState<any>();
    const [banheirosActual, setBanheirosAtual] = useState<any>();
    const [suitesActual, setSuitesAtual] = useState<any>();
    const [vagasActual, setVagasAtual] = useState<any>();
    const [codeActual, setCodeActual] = useState('');
    const [companyActual, setCompanyActual] = useState<any>(null);
    const [buscaAvan, setBuscaAvan] = useState<boolean>(false);
    // INC-0089 (cs604): o select de Condomínio vira "eliminatório" — lista só os condomínios com
    // imóvel publicado no tipo / cidade / bairro já escolhidos. Gate por codsite; fora dele
    // `condominioOpcoes` é o `allCompany` de sempre e nada muda.
    const {
        opcoes: condominioOpcoes,
        carregando: condominioCarregando,
        filtrado: condominioFiltrado,
    } = useCondominiosDependentes({
        ativo: condominioDependenteDe(site, codsite),
        todos: allCompany,
        tipos: typesActual,
        cidade: citiesActual,
        bairros: districtActual,
        origin,
        codsite,
        selecionado: companyActual,
        onLimparSelecionado: () => setCompanyActual(null),
    });
    const bannerSrc = urlBanner && urlBanner !== "undefined" ? urlBanner.replaceAll('"', "") : "";
    const isMobileView = Boolean(isMobile || isMobile1);
    const use2523MobileDefaultLayout = isSite2523 && isMobileView;
    const storageHost = site?.site || (typeof window !== 'undefined' ? window.location.host : '');
    const storageCodsite = codsite || site?.id || 0;
    const listCategoryStorageKey = getImoveisListCategoryStorageKey(storageHost, storageCodsite);
    const listStatesStorageKey = getImoveisListStatesStorageKey(storageHost, storageCodsite);
    const listStatesPaisStorageKey = getEstadosComPaisStorageKey(storageHost, storageCodsite);
    const listDatasStorageKey = getImoveisListDatasStorageKey(storageHost, storageCodsite);
    const listCaracteristicasStorageKey = getImoveisListCaracteristicasStorageKey(storageHost, storageCodsite);

    const readLocalArray = (key: string) => {
        if (typeof window === 'undefined') return [];
        const value = readJsonStorageValue<any>(window.localStorage, key, []);
        return Array.isArray(value) ? value : [];
    };

    const withReadyDeliveryOption = (value: any) => {
        const options = Array.isArray(value) ? value.filter(Boolean) : [];
        const readyItem = { label: 'ImÃ³vel Pronto', value: 1 };
        const remaining = options.filter(
            (item: any) => !(item?.label === readyItem.label && item?.value === readyItem.value)
        );

        return [readyItem, ...remaining];
    };

    const newFilter = useCallback(() => {
        // A faixa de preço vem de MIN/MAX dos imóveis daquela transação. Imobiliária que
        // só trabalha com venda devolve precos_locacao = {min:null,max:null}; entregar isso
        // ao slider deixava min/max NaN e o filtro de valores inutilizável (#796 cs693).
        // Só vale faixa com max > 0 — o resto cai pra faixa que existir.
        const util = (faixa: any) => (faixa && Number(faixa.max) > 0 ? faixa : null);
        const venda = util(valores?.precos_venda?.[0]);
        const locacao = util(valores?.precos_locacao?.[0]);
        const VAZIA = { min: 0, max: 0 };

        const transacao = (transacaoActual?.value || allTransacao?.[0]?.value || '').toLowerCase();
        if (transacao === 'aluguel' || transacao === 'temporada') {
            return locacao ?? venda ?? VAZIA;
        }
        if (transacao === 'venda') {
            return venda ?? locacao ?? VAZIA;
        }
        return venda ?? locacao ?? VAZIA;
    }, [allTransacao, transacaoActual, valores]);
    const getFiltersPricess = newFilter();
    const [filterPrice, setFilterPrice] = useState<any>(!getFiltersPricess?.min && !getFiltersPricess?.max ? { min: 0, max: 0 } : getFiltersPricess);
    // Number(...) explícito: min/max podem vir null da origem (faixa vazia) e o Slider
    // do MUI com valor null vira NaN — thumb some e o arraste não responde.
    const [value2, setValue2] = React.useState<number[]>([Number(getFiltersPricess?.min ?? 0), Number(getFiltersPricess?.max ?? 0)]);
    const minDistance = Math.max(0, Math.min(500, Number(filterPrice?.max || 0) - Number(filterPrice?.min || 0)));

    const handleChange2 = (
        event: Event,
        newValue: number | number[],
        activeThumb: number,
      ) => {
        if (!Array.isArray(newValue)) {
          return;
        }

        const rangeMin = Number(filterPrice?.min || 0);
        const rangeMax = Number(filterPrice?.max || 0);

        if (newValue[1] - newValue[0] < minDistance) {
          if (activeThumb === 0) {
            const clamped = Math.max(rangeMin, Math.min(newValue[0], value2[1] - minDistance));
            setValue2([clamped, clamped + minDistance]);
          } else {
            const clamped = Math.min(rangeMax, Math.max(newValue[1], value2[0] + minDistance));
            setValue2([clamped - minDistance, clamped]);
          }
        } else {
          setValue2(newValue as number[]);
        }
        setBuscaAvan(true);
      };

    // cs2551: preco DIGITAVEL. Enquanto o campo esta em edicao guardamos o texto cru (so digitos);
    // fora da edicao o campo espelha o valor do Slider ja formatado. Sem isso, formatar a cada
    // tecla ("3" -> "3,00") deixa impossivel digitar.
    const [precoTexto, setPrecoTexto] = useState<Array<string | null>>([null, null]);

    // Campo vazio = "sem limite" desse lado (piso no minimo, teto no maximo): quem apaga tudo pra
    // redigitar nao ve a faixa colapsar no meio da digitacao.
    const precoDigitadoParaValor = (indice: number, digitos: string) => {
        const rangeMin = Number(filterPrice?.min || 0);
        const rangeMax = Number(filterPrice?.max || 0);
        const bruto = digitos === '' ? (indice === 0 ? rangeMin : rangeMax) : Number(digitos);
        // Fora da faixa de precos dos imoveis o Slider perde a bolinha; o digitado e' preso a ela.
        return Math.min(rangeMax, Math.max(rangeMin, bruto));
    };

    const onChangePrecoDigitado = (indice: number, texto: string) => {
        const digitos = texto.replace(/\D/g, '');
        setPrecoTexto((atual) => {
            const proximo = [...atual];
            proximo[indice] = digitos;
            return proximo;
        });

        const digitado = precoDigitadoParaValor(indice, digitos);
        // Enquanto digita, o outro extremo NAO se mexe — so a ordem e' respeitada (min > max quebra
        // o Slider do MUI). Mexer nele aqui destruiria o valor ja digitado do outro campo: teclar o
        // "9" de 900.000 no maximo chegaria como 9 e empurraria o minimo.
        const proximoValor = indice === 0
            ? [Math.min(digitado, Number(value2[1] || 0)), Number(value2[1] || 0)]
            : [Number(value2[0] || 0), Math.max(digitado, Number(value2[0] || 0))];

        setValue2(proximoValor);
        setBuscaAvan(true);
    };

    // Ao sair do campo o texto cru some e volta a leitura formatada — inclusive quando o digitado
    // foi preso ao teto da faixa, deixando claro qual valor a busca vai usar. So aqui, com o numero
    // completo, vale empurrar o outro extremo: quem digita um minimo acima do maximo quer "a partir
    // de X", e travar os dois no mesmo valor devolveria busca vazia.
    const onBlurPrecoDigitado = (indice: number) => {
        const texto = precoTexto[indice];
        setPrecoTexto([null, null]);
        if (texto === null || texto === undefined) return;

        const rangeMin = Number(filterPrice?.min || 0);
        const rangeMax = Number(filterPrice?.max || 0);
        const digitado = precoDigitadoParaValor(indice, texto);

        if (indice === 0 && digitado > Number(value2[1] || 0)) {
            setValue2([digitado, rangeMax]);
        } else if (indice === 1 && digitado < Number(value2[0] || 0)) {
            setValue2([rangeMin, digitado]);
        }
    };

    const valorCampoPreco = (indice: number) => {
        const emEdicao = precoTexto[indice];
        if (emEdicao !== null && emEdicao !== undefined) return emEdicao;
        return toPrice(Number(value2[indice] || 0), 0);
    };

    // methods
    // MULTI-FILIAIS: preserva a filial ativa nos links de busca do hero.
    const withRegiao = useRegiaoHref();

    const renderPath = () => {
        const transacao = (transacaoActual?.value || allTransacao[0]?.value || 'venda').toLowerCase();
        // Cidade fixa estrita: com CÓDIGO digitado, cidade e bairro saem da busca —
        // senão a cidade fixa esconderia imóvel de outra cidade (utils/condominiosBusca).
        const codigoVenceCidade = buscaCidadeFixaEstrita(site?.id) && !!codeActual;
        const cidade = (codigoVenceCidade ? '-' : citiesActual?.label ? hifenUrl(citiesActual?.label, site?.id) : undefined) || '-';
        const bairro = (codigoVenceCidade ? '-' : urlDistrict ? hifenUrl(urlDistrict, site?.id) : undefined) || '-';
        const empreendimento = (companyActual?.label ? hifenUrl(companyActual?.label, site?.id) : undefined) || '-';
        const tipo = (urlTipo ? hifenUrl(urlTipo, site?.id) : undefined) || '-';
        const codigo = codeActual ? `/${codeActual.replaceAll(' ', '%20')}` : '';

        const params = new URLSearchParams();
        // Categoria fixa (opção "Lançamentos"): a listagem só lê `?categoria=` no shape avançado,
        // então ligá-la implica mandar os campos avançados junto — é o formato do link que o
        // cliente já usa (…?min=…&max=…&categoria=10732&dormitorios=0&…).
        const shouldUseAdvanced =
            buscaAvan || categoriaFixa != null || site?.id == 2297 || site?.id == 1942 || site?.id == 2065;
        const isEmptySite2551Search =
            Number(site?.id) === 2551 &&
            !codeActual &&
            !citiesActual?.label &&
            !urlDistrict &&
            !companyActual?.label &&
            !urlTipo &&
            !shouldUseAdvanced;

        if (shouldUseAdvanced) {
            if (filtroPais && paisActual?.value) params.set(PAIS_QUERY_PARAM, String(paisActual.value));
            if (estadoActual?.value) params.set('id_estado', String(estadoActual.value));
            params.set('min', String(value2?.[0] || 0));
            params.set('max', String(value2?.[1] || 0));
            if (urlDatas) params.set('data_entrega', String(urlDatas));
            // A categoria fixa da barra vence o select de categoria do avançado: o visitante
            // escolheu "Lançamentos" explicitamente no toggle.
            if (categoriaFixa != null) params.set('categoria', String(categoriaFixa));
            else if (showHomeCategoria && categoryActual?.value) params.set('categoria', String(categoryActual.value));
            if (showHomeDormitorios) params.set('dormitorios', String(dormitoriosActual?.value || 0));
            params.set('banheiros', String(banheirosActual?.value || 0));
            params.set('suites', String(suitesActual?.value || 0));
            params.set('vagas', String(vagasActual?.value || 0));
            if (showHomeCaracteristicas && urlCaract) params.set('id_caracteristica', String(urlCaract));
        }
        if (isEmptySite2551Search) {
            params.set('ordem', 'desc-inclusao');
        }
        // MULTI-FILIAIS: 2+ cidades marcadas viram `?cidades=<ids>` (o segmento de
        // cidade do caminho já sai '-', porque citiesActual fica null). Ver
        // resolveCidadesBusca — é ele que decide a precedência na listagem.
        if (cidadesMulti.queryCidades) params.set('cidades', cidadesMulti.queryCidades);

        let newPath = `/imoveis/${transacao}/${cidade}/${bairro}/${empreendimento}/${tipo}${codigo}`;
        if (params.toString()) {
            newPath = `${newPath}?${params.toString()}`;
        }

        newPath = appendCodsiteQuery(newPath, codsite2, origin);
        // MULTI-FILIAIS: a busca leva a filial ativa para a listagem (?regiao=).
        return withRegiao(removerAcentos(newPath).toLowerCase().replaceAll(' ', '-'));
    };
    // Meta Pixel: evento Search no clique de "Buscar" (não trava a navegação; alimenta a
    // dedup do Search CAPI da listagem via sessionStorage 'meta:searchEventId').
    const fireMetaSearch = () => {
        if (site?.id == "1937") return; // 1937: o botão é "Fale com a Leila" (WhatsApp), não busca
        const transacaoNome = transacaoActual?.label || transacaoActual?.value || allTransacao[0]?.value || '';
        const tipoNome = (typesActual || []).map((t: any) => t?.label).filter(Boolean).join(', ');
        const cidadeNome = citiesActual?.label || '';
        const bairroNome = (districtActual || []).map((d: any) => d?.label).filter(Boolean).join(', ');
        const searchString = [transacaoNome, tipoNome, cidadeNome, bairroNome].filter(Boolean).join(' | ');
        const eventId = genMetaEventId();
        try { sessionStorage.setItem('meta:searchEventId', JSON.stringify({ id: eventId, at: Date.now() })); } catch { /* sessionStorage indisponível — Search sai sem dedup c/ CAPI */ }
        trackMetaEvent(site, 'Search', {
            search_string: searchString,
            transaction_type: transacaoNome,
            property_type: tipoNome,
            city: cidadeNome,
            neighborhood: bairroNome,
        }, { eventId });
    };
    const onChangeCity = useCallback(async (txt: any) => {
        if (!txt) {
            setCitiesActual(null);
            setDistrictActual([]);
            setAllDistrict([]);
            return;
        }
        if (citiesActual?.value === txt?.value) return;
        setCitiesActual(txt);
        const infoDistrict = await district(txt.value, origin, codsite);
        setAllDistrict(formatSelects(infoDistrict?.bairros));
        setDistrictActual([])
    }, [citiesActual?.value, codsite, origin]);
    // MULTI-FILIAIS: no modo popup o select de cidade vira multi (1..N cidades da
    // filial). Fora dele `selectProps` é {} e o <Select> continua o de sempre.
    const cidadesMulti = useCidadesMulti(onChangeCity, allCitiesAux);
    // Cidade fixa na busca (CRM → Comportamento): abre o formulário já com a cidade do tenant.
    useCidadeFixaBusca(site?.cidade_busca, allCitiesAux, Boolean(citiesActual), onChangeCity);
    const onChangeDistrict = (txt: any) => {
        setUrlDistrict(txt?.map((tip: any) => {return tip?.label}).join("+"))
        setDistrictActual(txt);
    };
    const onChangeCompany = (txt: any) => {
        setCompanyActual(txt);
    };
    const onChangeTypes = (txt: any) => {
        setUrlTipo(txt?.map((tip: any) => {return tip?.label}).join("+"))
        setTypesActual(txt);
    };
    const onChangeCategory = (txt: any) => {
        if(categoryActual == txt)
            setCategoryActual([]);
        else
        setCategoryActual(txt);

        setBuscaAvan(true);
    };
    const onChangeEstado = async (txt: any) => {
        if(estadoActual == txt) {
            setEstadoActual(null);
            // cs2065: sem estado, a cidade pode ser de qualquer estado do país escolhido.
            if (filtroPais) setAllCitiesAux(cidadesDoPais(allCities, listEstados, paisActual?.value));
        }
        else{
            // selecionou um novo estado
            setEstadoActual(txt);
            // cs2065: o País acompanha o estado escolhido.
            if (filtroPais) setPaisActual(paisDoEstado(listEstados, txt?.value) || paisActual);

            // filtra apenas as cidades que batem com o id_estado
            const cidadesFiltradas = allCities.filter(
                city => city?.id_estado === txt.value
            );

            setCitiesActual(null);
            setDistrictActual([])
            setAllCitiesAux(cidadesFiltradas);
        }
    };
    // cs2065: trocar o País limpa o Estado que não é dele e deixa só as cidades do país.
    // Escolher de novo o país já marcado desmarca (mesmo comportamento do Estado acima).
    const onChangePais = (txt: any) => {
        const pais = txt?.value && txt.value !== paisActual?.value ? txt : null;
        setPaisActual(pais);
        const estadoFica = Boolean(
            pais && estadoActual?.value && paisDoEstado(listEstados, estadoActual.value)?.value === pais.value
        );
        if (!estadoFica) setEstadoActual(null);
        setCitiesActual(null);
        setDistrictActual([]);
        setAllCitiesAux(
            estadoFica
                ? allCities.filter((city) => city?.id_estado === estadoActual.value)
                : cidadesDoPais(allCities, listEstados, pais?.value)
        );
    };
    const onChangeDataEntrega = (txt: any) => {
        setUrlDatas(txt?.map((tip: any) => {return tip?.value}).join(","))
        setDataEntregaActual(txt);
        if(txt?.length > 0)
            setBuscaAvan(true);
    };
    const onChangeCaracteristicas = (txt: any) => {
        setUrlCaract(txt?.map((tip: any) => {return tip?.value}).join(","))
        setCaractActual(txt);
        if(txt?.length > 0)
            setBuscaAvan(true);
    };
    const onInputChangeCompany = (txt: any) => {
        setCompanyInputActual(txt);
    };
    const onChangeTransacao = (txt: any) => {
        setTransacaoActual(txt);
    };
    const onChangeDormitorios = (txt: any) => {
        setDormitoriosAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeBanheiros = (txt: any) => {
        setBanheirosAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeSuites = (txt: any) => {
        setSuitesAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeVagas = (txt: any) => {
        setVagasAtual(txt);
        setBuscaAvan(true);
    };

    const onChangeCode = (txt: React.ChangeEvent<HTMLInputElement>) => {
        setCodeActual(txt.target.value);
    };

    const GetInitialFilters = useCallback(async () => {
        if(listEstados === 0 && filtroPais){
            // cs2065: estados com o país separado, em chave própria com validade (utils/filtroPais).
            setListEstados(await carregarEstadosComPais(listStatesPaisStorageKey, () => get_estados(origin, codsite)));
        } else if(listEstados === 0 && (site?.id == 2297 || site?.id == 1942)){
            const getCondo: any = readLocalArray(listStatesStorageKey);

            if(getCondo?.length > 0){
                setListEstados(getCondo);
            } else {
                const infoEstados = await get_estados(origin, codsite);
                const formatEstados = formatSelects(infoEstados?.estados);
                if(formatEstados?.length > 0){
                    localStorage.setItem(listStatesStorageKey, JSON.stringify(formatEstados));
                    setListEstados(formatEstados);
                }
                else
                setListEstados([]);
            }
        }

        if(listCategory === 0 && showHomeCategoria){
            const getCondo: any = readLocalArray(listCategoryStorageKey);

            if(getCondo?.length > 0){
                setListCategory(getCondo);
            } else {
                const infoCategory = await categorias(origin, codsite);
                const formatCategorias = formatSelects(infoCategory?.categorias);
                if(formatCategorias?.length > 0){
                    localStorage.setItem(listCategoryStorageKey, JSON.stringify(formatCategorias));
                    setListCategory(formatCategorias);
                }
                else
                    setListCategory([]);
            }
        }

        if(listCaracteristicas === 0 && showHomeCaracteristicas){
            const getCondo = getWithTTL<any>(listCaracteristicasStorageKey);

            if(getCondo?.length > 0){
                setListCaracteristicas(getCondo);
            } else {
                const infoCaracteristicas= await allCaracteristicas(origin, codsite);
                const formatCarac = formatCaracteristicas(infoCaracteristicas?.caracteristicas);
                if(formatCarac?.length > 0){
                    setListCaracteristicas(formatCarac);
                    const DAY_MS = 24 * 60 * 60 * 1000; // 86_400_000
                    setWithTTL(listCaracteristicasStorageKey, formatCarac, DAY_MS);
                }
                else
                setListCaracteristicas([]);
            }
        }

        if(listDatas === 0 && site?.mostrar_data_entrega){
            const getCondo: any = readLocalArray(listDatasStorageKey);

            if(getCondo?.length > 0){
                const newItem = { "label": "Imóvel Pronto", "value": 1 };

                // Adiciona o novo item no início do array
                getCondo.unshift(newItem);
                setListDatas(withReadyDeliveryOption(getCondo));
            } else {
                const infoDatas= await allDatasEntrega(origin, codsite);
                const formatDatas = Array.isArray(infoDatas?.datas_entrega)
                    ? withReadyDeliveryOption(formatSelectsTransacao(infoDatas.datas_entrega))
                    : [];

                if(formatDatas?.length > 0){
                    const newItem = { "label": "Imóvel Pronto", "value": 1 };

                    // Adiciona o novo item no início do array
                    void newItem;
                    setListDatas(formatDatas);
                    localStorage.setItem(listDatasStorageKey, JSON.stringify(formatDatas));
                }
                else
                setListDatas([]);
            }
        }
    }, [codsite, filtroPais, listCaracteristicas, listCaracteristicasStorageKey, listCategory, listCategoryStorageKey, listDatas, listDatasStorageKey, listEstados, listStatesPaisStorageKey, listStatesStorageKey, origin, setListCaracteristicas, setListCategory, setListDatas, setListEstados, showHomeCaracteristicas, showHomeCategoria, site?.id, site?.mostrar_data_entrega]);

    const redirectToLink = useCallback(() => {
        const linkElement = document.getElementById("myLink");
        if (linkElement) {
          linkElement.click();
        }
    }, []);

    // #880 · cs2587 (Teomi): 2.975 dos 3.260 imóveis ativos estão em Taubaté, então a busca da
    // home nasce com essa cidade já marcada — mesmo espírito do GetOnlyCityCanoas() do 1772,
    // porém marcando de verdade (carrega os bairros e o botão Buscar já sai com a cidade).
    const isTaubateDefaultSite = site?.id == "2587";

    const GetOnlyCityTaubate = useCallback(() => {
        if (site?.id != "2587") return null;
        const GetOnlyType = (allCitiesAux || []).filter((e: any) => {
            return removerAcentos(String(e?.label ?? '')).trim().toLowerCase() == "taubate";
        });
        return GetOnlyType[0] || null;
    }, [allCitiesAux, site?.id]);

    // Aplica UMA vez: se o visitante trocar a cidade, a escolha dele é que vale.
    const defaultCity2587Applied = useRef(false);

    useEffect(() => {
        if (defaultCity2587Applied.current || citiesActual) return;
        const taubate = GetOnlyCityTaubate();
        if (!taubate) return;
        defaultCity2587Applied.current = true;
        onChangeCity(taubate);
    }, [GetOnlyCityTaubate, citiesActual, onChangeCity]);

    useEffect(() => {
        if((searchAdvanced || site?.id == 1684 || site?.id == 2146 || site?.id == 1803 || site?.id == 2297 || site?.id == 2065 || site?.id == 1942) && (showHomeCaracteristicas || showHomeCategoria || site?.mostrar_data_entrega)){
            GetInitialFilters()
        }
    }, [GetInitialFilters, searchAdvanced, showHomeCaracteristicas, showHomeCategoria, site?.id, site?.mostrar_data_entrega]);

    useEffect(() => {
    if (allCitiesAux?.length == 1 && Number(site?.id) !== 2523) {
        const onlyCity = allCitiesAux[0];
        if (citiesActual?.value !== onlyCity?.value) {
            onChangeCity(onlyCity);
        }
    }

    const handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === "Enter") {
            redirectToLink();
        }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
        document.removeEventListener("keydown", handleKeyDown);
    };
}, [allCitiesAux, citiesActual?.value, onChangeCity, redirectToLink, site?.id]);

    useEffect(() => {
        const next = newFilter();
        if (!next) return;

        const boundsChanged = filterPrice?.min !== next.min || filterPrice?.max !== next.max;
        if (!boundsChanged) return;

        setFilterPrice(next);
        setValue2([next.min, next.max]);
        // A faixa mudou (trocou a transacao): o texto em edicao do cs2551 nao vale mais.
        setPrecoTexto([null, null]);
    }, [filterPrice?.max, filterPrice?.min, newFilter]);

    // renders

    const renderArchives = () => {
        const mediaClassName = searchAdvanced ? styles.video_renderOn : styles.video_render;
        const fallbackMedia = bannerSrc ? (
            <Image
                className={`${mediaClassName} ${styles.media_fallback}`}
                alt="Banner"
                height={900}
                width={1600}
                sizes="100vw"
                src={bannerSrc}
                priority
            />
        ) : (
            <div
                className={`${mediaClassName} ${styles.media_fallback}`}
                aria-hidden="true"
            />
        );

        if (isMobileView && bannerSrc && site?.id != 1235) {
            return fallbackMedia;
        }

        if (!site?.url_video) {
            return fallbackMedia;
        }

        // MULTI-FILIAIS: com VÍDEO REGIONAL a variante mobile `_b.mp4` não existe
        // (não geramos derivadas por filial nesta fase) — cairia em 404.
        const videoSrc =
            isMobileView && site?.id == 1235 && !site?.url_video_regional
                ? site?.url_video.replace(".mp4","_b.mp4")
                : site?.url_video;

        return (
            <div className={styles.media_shell}>
                <video
                    autoPlay={!videoParado}
                    muted
                    loop
                    height="100%"
                    width="100%"
                    className={`${mediaClassName} ${styles.media_overlay}`}
                    poster={heroPoster}
                    src={heroPoster ? (heroVideoReady ? videoSrc : undefined) : videoSrc}
                    playsInline
                    preload={heroPoster ? 'none' : videoParado ? 'metadata' : 'auto'}
                >
                    <track kind="captions" label="Legenda" src="legenda.vtt"></track>
                </video>
            </div>
        );
    };

    const GetOnlyCityCanoas = () => {
        const GetOnlyType = allCitiesAux.filter((e: any) => {
            return String(e.label)=="Canoas";
        })
        return GetOnlyType[0];
    };
    return (
        <div className={`${styles.welcomeHero} ${searchAdvanced ? styles.welcomeHeroAdvanced : ''}`}>
            <div className={styles.welcomeHeroMedia}>
                {renderArchives()}
            </div>
            <DrawerComponent
                site={site}
                activeDrawer={activeDrawer}
                setActiveDrawer={setActiveDrawer}
                favorito={favorito}
                menus={props?.menus}
            />
            <div className={`${styles.header_welcome} ${isSite2523 ? styles.header_welcome2523 : ''}`}>
                <div className={`${styles.body} ${isSite2523 ? styles.body2523 : ''}`}>
                    <div
                        className={`${styles.container_adjust_text_header} ${shouldHideHeaderText ? styles.container_adjust_text_headerHidden : ''} ${isSite2523 ? styles.container_adjust_text_header2523 : ''}`}
                        data-site-id={site?.id}
                        aria-hidden={shouldHideHeaderText}
                    >
                            <div className={`${styles.container_adjust_text_header} ${shouldHideHeaderText ? styles.container_adjust_text_headerHidden : ''} ${isSite2523 ? styles.container_adjust_text_header2523 : ''}`}>
                                <div className={`${styles.adjust_text_header} ${isSite2523 ? styles.adjust_text_header2523 : ''} ${shouldHideHeaderText ? styles.adjust_text_headerHidden : ''}`} style={isSite2523 && !use2523MobileDefaultLayout ? {textAlign: "left"} : {}}>
                                    {mostraLogoNoHero(site) ? (
                                        // cs2580: logo grande e centralizada acima do título (allowlist em utils/logoNoHero)
                                        <Image
                                            data-site-logo-hero
                                            src={`${site?.url_logo}?v=${site?.contador_marca || 0}`}
                                            alt={`Imobiliária ${site?.Dados?.empresa}`}
                                            title={`Imobiliária ${site?.Dados?.empresa}`}
                                            width={240}
                                            height={240}
                                            className={styles.logoHero}
                                            priority
                                            fetchPriority="high"
                                            unoptimized
                                        />
                                    ) : null}
                                    {site?.frase_busca ?
                                    site?.id == '2112' ?
                                    <motion.h1
                                        alt="Título"
                                        className={`${styles.text_header} ${isSite2523 ? styles.text_header2523 : ''}`}
                                        style={{fontSize: '64px', margin: '0px'}}
                                        dangerouslySetInnerHTML={{
                                            __html: site?.frase_busca.toUpperCase(),
                                        }}
                                        initial={{ opacity: 0, y: 50 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{
                                            delay: 0,
                                            duration: 0.45,
                                            ease: "easeOut"
                                        }}
                                    ></motion.h1>
                                    :
                                    <motion.h1
                                        alt="Título"
                                         className={`${styles.text_header} ${isSite2523 ? styles.text_header2523 : ''}${isSite2644 ? ` ${styles.text_headerMobile2644}` : ''}`}
                                        style={
                                        isSite2523 && !use2523MobileDefaultLayout
                                            ? {
                                                fontSize: '36px',
                                                marginBottom: '20px'
                                            }
                                            : site?.id == 2102 || site?.id == 2507
                                            ? { fontSize: 36 }
                                            : site?.id == 1992
                                            ? { fontSize: 38 }
                                            : site?.id == 2165 || site?.id == 1630
                                            ? { fontWeight: 500 }
                                            : site?.id == 1730
                                            ? { color: "#eacba6" }
                                            : site?.id == '2127'
                                            ? { margin: 0 }
                                            : site?.id == 2126
                                            ? { color: "#ab0303", fontSize: 40 }
                                            : {}
                                    }
                                        dangerouslySetInnerHTML={{
                                            __html: fontesMaiores ? tituloEmDuasLinhas(site?.frase_busca) : site?.frase_busca,
                                          }}
                                        initial={{ opacity: 0, y: 50 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{
                                            delay: 0,
                                            duration: 0.45,
                                            ease: "easeOut"
                                        }}
                                    ></motion.h1>
                                    : null}
                                    {site?.frase_busca_2 ?
                                        <motion.h2
                                            alt="Subtitulo"
                                            initial={{ opacity: 0, y: 50 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{
                                                delay: 0.05,
                                                duration: 0.45,
                                                ease: "easeOut"
                                            }}
                                            className={`${styles.text_header2} ${isSite2523 ? styles.text_header22523 : ''}${fontesMaiores ? ` ${styles.text_header2Destaque}` : ''}${isSite2644 ? ` ${styles.text_headerMobile2644}` : ''}`}
                                            style={
                                                isSite2523 && !use2523MobileDefaultLayout
                                                    ? {
                                                        fontSize: '26px'
                                                    }
                                                    : site?.id == "1832"
                                                    ? { display: "block" }
                                                    : site?.id == 1992 || site?.id == 2507
                                                    ? { fontSize: 25 }
                                                    : site?.id == '2103'
                                                    ? { fontSize: '24px', fontFamily: 'Roboto' }
                                                    : site?.id == '2127'
                                                    ? { fontSize: '26px' }
                                                    : site?.id == '2348'
                                                    ? { fontSize: '24px' }
                                                    : {}
                                            }>
                                            {site?.frase_busca_2}
                                        </motion.h2>
                                    : null}
                                </div>
                            </div>
                        </div>
                    <div
                        className={isSite2523 ? styles.searchCardWrapper2523 : ''}
                        style={isSite2523 && !use2523MobileDefaultLayout ? {justifyContent: "flex-start", display: "block", width: "100%",maxWidth: "1300px"} : {justifyContent: "center", display: "block", width: "100%"}}
                    >
                        { site?.id != "1999" ?
                            <motion.div
                                alt="Filtros"
                                className={`${site?.id == "2057" ? styles.adjust_selects2 : styles.adjust_selects} ${isSite2523 ? styles.adjust_selects2523 : ''} ${aiSearch ? styles.adjust_selectsComIa : ''}`}
                                style={
                                    site?.id == "1937"
                                        ? { background: "none" }
                                        : isSite2523 && !use2523MobileDefaultLayout
                                        ? { background: "transparent" }
                                        : { background: `${site?.cor12 + 50}` }
                                }
                                initial={{ opacity: 0, y: 50 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{
                                    delay: 0.08,
                                    duration: 0.45,
                                    ease: "easeOut"
                                }}
                            >
                                {aiSearch ? (
                                    <div className={styles.aiSlot}>
                                        {aiSearch({
                                            transacao: String(transacaoActual?.value || allTransacao?.[0]?.value || 'venda').toLowerCase(),
                                            filtrosAbertos: Boolean(searchAdvanced),
                                            onTransacaoChange: (value) => {
                                                const opt = (allTransacao || []).find(
                                                    (t) => String(t?.value || '').toLowerCase() === String(value || '').toLowerCase()
                                                );
                                                if (opt) onChangeTransacao(opt);
                                            },
                                            categoriaFixa,
                                            onCategoriaFixaChange: setCategoriaFixa,
                                        })}
                                    </div>
                                ) : null}
                                {/* Com a barra de IA (hero 10), os filtros clássicos ficam RECOLHIDOS até o
                                    visitante clicar em "Avançado" (pedido do Daniel 26/08): a home mostra só a
                                    frase livre; "Avançado" abre transação/tipo/cidade/… + os campos avançados. */}
                                <div
                                    className={`${styles.column} ${isSite2507 ? styles.column2507 : ''} ${filtroPais && listPaises.length > 0 ? styles.columnPais : ''}`}
                                    // display inline (não classe): `.column` é definida DEPOIS de
                                    // `.advancedOff` no CSS module, então a classe perderia a cascata.
                                    style={aiSearch && !searchAdvanced ? { display: 'none' } : undefined}
                                >
                                    { site?.id != "1937" ? <>
                                        {/* #1140 cs2618: Transação sai da busca — o submit segue com o
                                            default allTransacao[0] (transacaoActual já nasce com ele). */}
                                        {!isSite2618 ? (
                                        <div className={site?.id == "2297" || site?.id == 1942 || site?.id == 2065 ? styles.menu3 : site?.transacoes?.length > 1 ? styles.menu : styles.advancedOff} style={site?.id == "1819" ? {width: "33%"} : primarySearchFieldStyle2507}>
                                           <label htmlFor="home1-transacao" className={styles.visually_hidden}>
                                                {Number(site?.id) === 2523 ? "Tipo de Negócio" : "Escolha a Transação:"}
                                            </label>

                                            <Select
                                                inputId="home1-transacao"
                                                aria-label={Number(site?.id) === 2523 ? "Tipo de Negócio" : "Transação"}
                                                defaultValue={site?.id == 2470 || Number(site?.id) === 2523 ? null : allTransacao[0]}
                                                options={allTransacao}
                                                className={styles.select}
                                                placeholder={
                                                    Number(site?.id) === 2523
                                                        ? "Tipo de Negócio"
                                                        : site?.id == 2470
                                                        ? "Finalidade"
                                                        : allTransacao?.length > 0
                                                        ? allTransacao[0]?.value
                                                        : "Transação"
                                                }
                                                noOptionsMessage={() => 'Processando'}
                                                styles={colorPicker}
                                                value={transacaoActual}
                                                onChange={onChangeTransacao}
                                                instanceId={1}
                                                isSearchable={false}
                                            />
                                        </div>
                                        ) : null}
                                        {(site?.id == "1684" || site?.id == "2146" || site?.id == "1803") && showHomeCategoria && listCategory?.length > 0 &&
                                        <div className={styles.menu}>
                                            <label htmlFor="react-select-2-input" className={styles.visually_hidden}>Categoria:</label>
                                            <Select
                                                options={listCategory}
                                                className={styles.select}
                                                placeholder="Categoria"
                                                noOptionsMessage={() =>
                                                    'Categoria não encontrada'
                                                }
                                                styles={colorPicker}
                                                onChange={onChangeCategory}
                                                value={categoryActual}
                                                instanceId={3}
                                                isSearchable={isMobile || isMobile1 ? false : true}
                                            />
                                        </div>}
                                        {/* #1140 cs2618: Tipo sai da busca — sem seleção, urlTipo fica vazio
                                            e o path da busca usa o curinga '-'. */}
                                        {!isSite2618 ? (
                                        <div className={site?.id == "2297" || site?.id == 1942 || site?.id == 2065 ? styles.menu3 : site?.id == "2297" || site?.id == 2065 ? styles.menu3 : site?.transacoes?.length > 1 || site?.id == "2148" || site?.id == "2480" || site?.id == "1684" || site?.id == "1955" || site?.id == "1961" || site?.id == "2351" || site?.id == "2297" || site?.id == 2065 || site?.id == "1630" || site?.id == "604" || site?.id == "2387" || site?.id == "2146" || site?.id == "1803" ? styles.menu : styles.menu1} style={site?.id == "1819" ? {width: "33%"} : primarySearchFieldStyle2507}>
                                            <label htmlFor="home1-tipo-imovel" className={styles.visually_hidden}>Escolha o Tipo:</label>
                                            <Select
                                                inputId="home1-tipo-imovel"
                                                aria-label="Tipo de imóvel"
                                                options={allTypes}
                                                className={styles.select}
                                                isMulti
                                                placeholder={urlTipo ? typesActual?.length + " Selecionado (s)" : "Tipo de imóvel"}
                                                styles={colorPicker}
                                                closeMenuOnSelect={site?.id == "2091" ? true : false}
                                                controlShouldRenderValue={false}
                                                noOptionsMessage={() =>
                                                    'Tipo não encontrado'
                                                }
                                                hideSelectedOptions={false}
                                                tabSelectsValue={false}
                                                value={typesActual}
                                                onChange={onChangeTypes}
                                                closeMenuOnScroll={true}
                                                isSearchable={isMobile || isMobile1 ? false : true}
                                                instanceId={2}
                                            />
                                        </div>
                                        ) : null}
                                        {filtroPais && listPaises.length > 0 &&
                                            <div className={styles.menu3}>
                                                <label htmlFor="home1-pais" className={styles.visually_hidden}>País:</label>
                                                <Select
                                                    inputId="home1-pais"
                                                    aria-label="País"
                                                    options={listPaises}
                                                    className={styles.select}
                                                    placeholder="País"
                                                    noOptionsMessage={() =>
                                                        'País não encontrado'
                                                    }
                                                    styles={colorPicker}
                                                    onChange={onChangePais}
                                                    value={paisActual}
                                                    instanceId={114}
                                                    isSearchable={isMobile || isMobile1 ? false : true}
                                                />
                                            </div>}
                                        {(site?.id == 2297 || site?.id == 1942 || site?.id == 2065) && listEstados &&
                                            <div className={styles.menu3}>
                                                <label htmlFor="react-select-2-input" className={styles.visually_hidden}>Estado:</label>
                                                <Select
                                                    options={estadosVisiveis}
                                                    className={styles.select}
                                                    placeholder="Estado"
                                                    noOptionsMessage={() =>
                                                        'Estado não encontrado'
                                                    }
                                                    styles={colorPicker}
                                                    onChange={onChangeEstado}
                                                    value={estadoActual}
                                                    instanceId={113}
                                                    isSearchable={isMobile || isMobile1 ? false : true}
                                                />
                                            </div>}

                                        {site?.id == "1819" || site?.id == "2507" ?
                                            site?.id == "2507" ?
                                                <div className={site?.transacoes?.length > 1 ? styles.menu : styles.menu1} style={primarySearchFieldStyle2507}>
                                                    <label htmlFor="home1-bairro" className={styles.visually_hidden}>Escolha o Bairro:</label>
                                                    <Select
                                                        inputId="home1-bairro"
                                                        aria-label="Bairro"
                                                        options={allDistrict}
                                                        className={styles.select}
                                                        placeholder={urlDistrict ? districtActual?.length + " Selecionado (s)" : "Bairro"}
                                                        closeMenuOnSelect={site?.id == "2091" ? true : false}
                                                        controlShouldRenderValue={false}
                                                        hideSelectedOptions={false}
                                                        tabSelectsValue={false}
                                                        noOptionsMessage={() =>
                                                            citiesActual ? 'Bairro não encontrado' : 'Selecione uma cidade'
                                                        }
                                                        isMulti
                                                        styles={colorPicker}
                                                        value={districtActual}
                                                        onChange={onChangeDistrict}
                                                        isSearchable={isMobile || isMobile1 ? false : true}
                                                        instanceId={4}
                                                    />
                                                </div>
                                            : null
                                        :<>
                                            {/* #1140 cs2618: Cidade sai da busca (uma cidade só) — o
                                                seletor some, mas citiesActual segue vindo do auto-select
                                                de cidade única / cidade fixa, então a URL não muda. */}
                                            {!isSite2618 ? (
                                            <div className={site?.id == "2297" || site?.id == 1942 || site?.id == 2065 ? styles.menu3 : site?.transacoes?.length > 1 || site?.id == "2148" || site?.id == "2480" || site?.id == "1684" || site?.id == "2297" || site?.id == 2065 || site?.id == "1630" || site?.id == "1955" || site?.id == "1961" || site?.id == "2351" || site?.id == "604" || site?.id == "2387" || site?.id == "2146" || site?.id == "1803" ? styles.menu : styles.menu1}>
                                                <label htmlFor="home1-cidade" className={styles.visually_hidden}>Escolha a Cidade:</label>
                                                <Select
                                                    inputId="home1-cidade"
                                                    aria-label="Cidade"
                                                    options={allCitiesAux}
                                                    className={styles.select}
                                                    placeholder="Cidade"
                                                    noOptionsMessage={() => 'Cidade não encontrada'}
                                                    styles={colorPicker}
                                                    onChange={onChangeCity}
                                                    value={Number(site?.id) === 2523 ? null : (!citiesActual && site?.id == "1772" ? GetOnlyCityCanoas() : (!citiesActual && isTaubateDefaultSite ? GetOnlyCityTaubate() : citiesActual))}
                                                    instanceId={3}
                                                    isSearchable={isMobile || isMobile1 ? false : true}
                                                    {...cidadesMulti.selectProps}
                                                />
                                            </div>
                                            ) : null}
                                            {/* cs2452: o Condomínio ocupa o lugar do Bairro na barra;
                                                o Bairro vai para a busca avançada (mesmo estado/handler). */}
                                            {!isSite2452 ? (
                                            <div className={site?.id == "2297" || site?.id == 1942 || site?.id == 2065 ? styles.menu3 : site?.transacoes?.length > 1 || site?.id == "2148" || site?.id == "2480" || site?.id == "1684" || site?.id == 2065 || site?.id == "2297" || site?.id == "1961" || site?.id == "1955" || site?.id == "2351" || site?.id == "1630" || site?.id == "604" || site?.id == "2387"  || site?.id == "2146" || site?.id == "1803" ? styles.menu : styles.menu1} style={searchFieldStyle2618}>
                                                <label htmlFor="home1-bairro" className={styles.visually_hidden}>Escolha o Bairro:</label>
                                                <Select
                                                    inputId="home1-bairro"
                                                    aria-label="Bairro"
                                                    options={allDistrict}
                                                    className={styles.select}
                                                    placeholder={urlDistrict ? districtActual?.length + " Selecionado (s)" : "Bairro"}
                                                    closeMenuOnSelect={site?.id == "2091" ? true : false}
                                                    controlShouldRenderValue={false}
                                                    hideSelectedOptions={false}
                                                    tabSelectsValue={false}
                                                    noOptionsMessage={() =>
                                                        citiesActual ? 'Bairro não encontrado' : 'Selecione uma cidade'
                                                    }
                                                    isMulti
                                                    styles={colorPicker}
                                                    value={districtActual}
                                                    onChange={onChangeDistrict}
                                                    isSearchable={isMobile || isMobile1 ? false : true}
                                                    instanceId={4}
                                                />
                                            </div>
                                            ) : null}
                                            { site?.id == "2480" || site?.id == "2148" || site?.id == "604" || site?.id == "2387"  || site?.id == "1955" || site?.id == "2351" || site?.id == "1630" || site?.id == "1961" || site?.id == "2274" || isSite2587 || isSite2452 ?
                                                <div className={site?.id == "2297" || site?.id == 1942 || site?.id == 2065 ? styles.menu3 : site?.transacoes?.length > 1 || site?.id == "2148" || site?.id == "2480" || site?.id == "2351" || site?.id == "1961" || site?.id == "1684" || site?.id == "1630" || site?.id == "604" || site?.id == "2387" || site?.id == "2146" || site?.id == "1803" ? styles.menu : styles.menu1}>
                                                    <label htmlFor="react-select-9-input" className={styles.visually_hidden}>Empreendimento:</label>
                                                    <Select
                                                        options={condominioOpcoes}
                                                        isLoading={condominioCarregando}
                                                        className={styles.select1}
                                                        placeholder={
                                                        site?.id == 1892
                                                            ? "Residenciais e loteamentos"
                                                            : site?.id == 2374
                                                            ? "Condomínio/Loteamento"
                                                            : isSite2587
                                                            ? ROTULO_EMPREENDIMENTO_2587
                                                            : "Condomínios"
                                                        }
                                                        styles={colorPicker}
                                                        value={companyActual}
                                                        inputValue={companyInputActual}
                                                        noOptionsMessage={() =>
                                                            condominioFiltrado ? 'Nenhum condomínio com imóvel nesse filtro' :
                                                            isSite2587
                                                                ? (allCompany?.length > 1 ? 'Empreendimento não encontrado' : 'Digite o nome do condomínio ou empreendimento')
                                                                : (allCompany?.length > 1 ? 'Condomínio não encontrado' : 'Digite o nome do condomínio')
                                                        }
                                                        instanceId={9}
                                                        onChange={onChangeCompany}
                                                        onInputChange={onInputChangeCompany}
                                                    />
                                                </div>
                                            : null }
                                        </>}

                                        {site?.id != "2274" && !isSite2587 ? (
                                            <div className={site?.id == "2297" || site?.id == 1942 || site?.id == 2065 ? styles.menu3 : site?.transacoes?.length > 1 || site?.id == "2148" || site?.id == "2480" || site?.id == "1684" || site?.id == "1955" || site?.id == "1961" || site?.id == "2351" || site?.id == "2118" || site?.id == 2065 || site?.id == "2297" || site?.id == "1630" || site?.id == "604" || site?.id == "2387" || site?.id == "2146" || site?.id == "1803" ? styles.menu : styles.menu1} style={site?.id == "1819" ? {width: "33%"} : isSite2618 ? searchFieldStyle2618 : primarySearchFieldStyle2507}>
                                                <label htmlFor="codigoDoImovel" className={styles.visually_hidden}>Escolha a Referência:</label>
                                                <input
                                                    className={styles.input}
                                                    placeholder=" Código"
                                                    value={codeActual}
                                                    onChange={onChangeCode}
                                                    id="codigoDoImovel"
                                                    type="text"
                                                />
                                            </div>
                                        ) : null}
                                        <div className={searchAdvanced ? styles.advanced : styles.advancedOff}>
                                            {(site?.id != "1684" && site?.id != "2146" && site?.id != "1803") && showHomeCategoria && listCategory?.length > 0 &&
                                            <div className={site?.id == "2297" || site?.id == 2065 ? styles.menu3 : styles.menu2}>
                                                <label htmlFor="react-select-11-input" className={styles.visually_hidden}>Categoria:</label>
                                                <Select
                                                    options={listCategory}
                                                    className={styles.select}
                                                    placeholder="Categoria"
                                                    noOptionsMessage={() =>
                                                        'Categoria não encontrada'
                                                    }
                                                    styles={colorPicker}
                                                    onChange={onChangeCategory}
                                                    value={categoryActual}
                                                    instanceId={3}
                                                    isSearchable={isMobile || isMobile1 ? false : true}
                                                />
                                            </div>}
                                            {(site?.id != "1684" && site?.id != "2146" && site?.id != "1803") && showHomeCaracteristicas && listCaracteristicas?.length > 0 &&
                                            <div className={site?.id == "2297" || site?.id == 2065 ? styles.menu3 : styles.menu2}>
                                                <label htmlFor="react-select-11-input" className={styles.visually_hidden}>Características:</label>
                                                <Select
                                                    options={listCaracteristicas}
                                                    className={styles.select}
                                                    isMulti
                                                    placeholder={urlCaract ? caractActual?.length + " Selecionada (s)" : "Características"}
                                                    noOptionsMessage={() =>
                                                        'Característica não encontrada'
                                                    }
                                                    styles={colorPicker}
                                                    closeMenuOnSelect={false}
                                                    controlShouldRenderValue={false}
                                                    hideSelectedOptions={false}
                                                    tabSelectsValue={false}
                                                    onChange={onChangeCaracteristicas}
                                                    value={caractActual}
                                                    closeMenuOnScroll={false}
                                                    instanceId={12}
                                                    isSearchable={isMobile || isMobile1 ? false : true}
                                                />
                                            </div>}
                                            {site?.mostrar_data_entrega && listDatas?.length > 0 &&
                                                <div className={site?.id == "2297" || site?.id == 2065 ? styles.menu3 : styles.menu2}>
                                                    <label htmlFor="react-select-111-input" className={styles.visually_hidden}>Data Entrega:</label>
                                                        <Select
                                                            options={listDatas}
                                                            className={styles.select}
                                                            isMulti
                                                            placeholder={urlDatas ? dataEntregaActual?.length + " Selecionada (s)" : "Datas de entrega"}
                                                            noOptionsMessage={() =>
                                                                'Data de entrega não encontrada'
                                                            }
                                                            styles={colorPicker}
                                                            closeMenuOnSelect={false}
                                                            controlShouldRenderValue={false}
                                                            hideSelectedOptions={false}
                                                            tabSelectsValue={false}
                                                            onChange={onChangeDataEntrega}
                                                            value={dataEntregaActual}
                                                            closeMenuOnScroll={false}
                                                            instanceId={12}
                                                            isSearchable={isMobile || isMobile1 ? false : true}
                                                        />
                                                </div>
                                            }
                                            <div className={site?.id == "2297" || site?.id == 2065 ? styles.menu3 : styles.menu2} style={advancedFirstFieldStyle2507}>
                                                <label htmlFor="react-select-6-input" className={styles.visually_hidden}>Banheiros:</label>
                                                <Select
                                                    options={allOptions}
                                                    className={styles.select}
                                                    placeholder={banheirosActual?.value == 1 ? "1 Banheiro" : (banheirosActual?.label || "") + " Banheiros"}
                                                    styles={colorPicker}
                                                    value={banheirosActual}
                                                    onChange={onChangeBanheiros}
                                                    isSearchable={false}
                                                    instanceId={6}
                                                    controlShouldRenderValue={false}
                                                />
                                            </div>
                                            <div className={site?.id == "2297" || site?.id == 2065 ? styles.menu3 : styles.menu2} style={advancedFieldStyle2507}>
                                                <label htmlFor="react-select-5-input" className={styles.visually_hidden}>Quartos:</label>
                                                <Select
                                                    options={allOptions}
                                                    className={styles.select}
                                                    placeholder={dormitoriosActual?.value == 1 ? "1 Quarto" : (dormitoriosActual?.label || "") + " Quartos"}
                                                    styles={colorPicker}
                                                    value={dormitoriosActual}
                                                    onChange={onChangeDormitorios}
                                                    isSearchable={false}
                                                    instanceId={5}
                                                    controlShouldRenderValue={false}
                                                />
                                            </div>
                                            {site?.id != "2507" ?
                                                <div className={site?.id == "2297" || site?.id == 2065 ? styles.menu3 : styles.menu2} style={advancedFieldStyle2507}>
                                                    <label htmlFor="react-select-7-input" className={styles.visually_hidden}>Suítes:</label>
                                                    <Select
                                                        options={allOptions}
                                                        className={styles.select}
                                                        placeholder={suitesActual?.value == 1 ? "1 Suíte" : (suitesActual?.label || "") + " Suítes"}
                                                        styles={colorPicker}
                                                        value={suitesActual}
                                                        onChange={onChangeSuites}
                                                        instanceId={7}
                                                        isSearchable={false}
                                                        controlShouldRenderValue={false}
                                                    />
                                                </div>
                                            : null }
                                            <div className={site?.id == "2297" || site?.id == 2065 ? styles.menu3 : styles.menu2} style={advancedFieldStyle2507}>
                                                <label htmlFor="react-select-8-input" className={styles.visually_hidden}>Vagas:</label>
                                                <Select
                                                    options={allOptions}
                                                    className={styles.select}
                                                    placeholder={vagasActual?.value == 1 ? "1 Vaga" : (vagasActual?.label || "") + " Vagas"}
                                                    styles={colorPicker}
                                                    value={vagasActual}
                                                    onChange={onChangeVagas}
                                                    instanceId={8}
                                                    isSearchable={false}
                                                    controlShouldRenderValue={false}
                                                />
                                            </div>
                                            { site?.exibir_empreendimento && !isSite2587 && !isSite2452 && site?.id != "604" && site?.id != "2148"  && site?.id != "2387" && site?.id != "1630" && site?.id != "1961" && site?.id != "1955" && site?.id != "2351" ?
                                                <div className={site?.id == "2297" || site?.id == 2065 ? styles.menu3 : styles.pricefilter}>
                                                    <label htmlFor="react-select-9-input" className={styles.visually_hidden}>Empreendimento:</label>
                                                    <Select
                                                        options={condominioOpcoes}
                                                        isLoading={condominioCarregando}
                                                        className={styles.select1}
                                                        placeholder={
                                                        site?.id == "1892"
                                                            ? "Residenciais e loteamentos"
                                                            : site?.id == 2374
                                                            ? "Condomínio/Loteamento"
                                                            : "Condomínios"
                                                        }
                                                        styles={colorPicker}
                                                        value={companyActual}
                                                        inputValue={companyInputActual}
                                                        noOptionsMessage={() =>
                                                            condominioFiltrado ? 'Nenhum condomínio com imóvel nesse filtro' :
                                                            allCompany?.length > 1 ? 'Condomínio não encontrado' : 'Digite o nome do condomínio'
                                                        }
                                                        instanceId={9}
                                                        onChange={onChangeCompany}
                                                        onInputChange={onInputChangeCompany}
                                                    />
                                                </div>
                                            : null }
                                            {isSite2452 ? (
                                                <div className={styles.pricefilter}>
                                                    <label htmlFor="home1-bairro" className={styles.visually_hidden}>Escolha o Bairro:</label>
                                                    <Select
                                                        inputId="home1-bairro"
                                                        aria-label="Bairro"
                                                        options={allDistrict}
                                                        className={styles.select1}
                                                        placeholder={urlDistrict ? districtActual?.length + " Selecionado (s)" : "Bairro"}
                                                        closeMenuOnSelect={false}
                                                        controlShouldRenderValue={false}
                                                        hideSelectedOptions={false}
                                                        tabSelectsValue={false}
                                                        noOptionsMessage={() =>
                                                            citiesActual ? 'Bairro não encontrado' : 'Selecione uma cidade'
                                                        }
                                                        isMulti
                                                        styles={colorPicker}
                                                        value={districtActual}
                                                        onChange={onChangeDistrict}
                                                        isSearchable={isMobile || isMobile1 ? false : true}
                                                        instanceId={4}
                                                    />
                                                </div>
                                            ) : null}
                                            {isSite2587 ? (
                                                <div className={site?.id == "2297" || site?.id == 2065 ? styles.menu3 : styles.pricefilter}>
                                                    <label htmlFor="codigoDoImovelAvancado2587" className={styles.visually_hidden}>Escolha a Referência:</label>
                                                    <input
                                                        className={styles.input}
                                                        placeholder=" Código"
                                                        value={codeActual}
                                                        onChange={onChangeCode}
                                                        id="codigoDoImovelAvancado2587"
                                                        type="text"
                                                    />
                                                </div>
                                            ) : null}
                                            <div className={styles.pricefilter} style={{padding: "0px 0px 0px 5%"}}>
                                                <div className={styles.adjust_select_price}>
                                                    <div className={styles.title_select}>
                                                        PREÇOS
                                                    </div>
                                                    <div className={styles.adjust_prices}>
                                                        {isSite2551 ? (
                                                            <>
                                                                <div className={styles.price_field}>
                                                                    <label htmlFor="precoMinimoHome" className={styles.visually_hidden}>Preço mínimo</label>
                                                                    <span className={styles.price_prefix} aria-hidden="true">De {site?.moeda_tipo}</span>
                                                                    <input
                                                                        id="precoMinimoHome"
                                                                        className={styles.price_input}
                                                                        type="text"
                                                                        inputMode="numeric"
                                                                        autoComplete="off"
                                                                        value={valorCampoPreco(0)}
                                                                        onChange={(e) => onChangePrecoDigitado(0, e.target.value)}
                                                                        onBlur={() => onBlurPrecoDigitado(0)}
                                                                    />
                                                                </div>
                                                                <div className={`${styles.price_field} ${styles.price_field_max}`}>
                                                                    <label htmlFor="precoMaximoHome" className={styles.visually_hidden}>Preço máximo</label>
                                                                    <span className={styles.price_prefix} aria-hidden="true">Até {site?.moeda_tipo}</span>
                                                                    <input
                                                                        id="precoMaximoHome"
                                                                        className={styles.price_input}
                                                                        type="text"
                                                                        inputMode="numeric"
                                                                        autoComplete="off"
                                                                        value={valorCampoPreco(1)}
                                                                        onChange={(e) => onChangePrecoDigitado(1, e.target.value)}
                                                                        onBlur={() => onBlurPrecoDigitado(1)}
                                                                    />
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className={styles.price}>
                                                                    {`${site?.moeda_tipo} ${toPrice(Number(value2[0]),2
                                                                    )}`}
                                                                </div>
                                                                <div className={styles.price}>
                                                                    {`${site?.moeda_tipo} ${toPrice(
                                                                        Number(value2[1]),2
                                                                    )}`}
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                    <Slider
                                                        getAriaLabel={() => 'Minimum distance shift'}
                                                        value={value2}
                                                        onChange={handleChange2}
                                                        valueLabelDisplay="auto"
                                                        min={Number(filterPrice?.min ?? 0)}
                                                        max={Number(filterPrice?.max ?? 0)}
                                                        step={transacaoActual?.value == "Aluguel" ? 100 : 10000}
                                                        style={{
                                                            color: `${'rgb(255, 255, 255)'}`,
                                                        }}
                                                        getAriaValueText={valuetext}
                                                        disableSwap
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null}
                                    <div className={styles.menuBottom}>
                                        <Link
                                            prefetch={false}
                                            href={site?.id != "1937" ? renderPath() : `https://api.whatsapp.com/send?phone=${(
                                            site?.Dados?.tel1 ||
                                            site?.Dados?.tel2 ||
                                            site?.Dados?.tel3 ||
                                            site?.Dados?.tel4
                                            )?.replace(/\D/g, '')}&text=Olá, estou no site da ${site?.titulo} Visitando a página https://${site?.site} pode me ajudar?`}
                                            id="myLink"
                                            onClick={fireMetaSearch}
                                            title={`Buscar ${typesActual[0] ? typesActual[0]?.label : 'imóveis'}${districtActual[0] ? ' em '+ districtActual[0]?.label : ''}${citiesActual?.label ? ' - '+ citiesActual?.label : ''}${codeActual ? ' - Imóvel código: '+ codeActual : ''}`}
                                            className={site?.id == "1937" ? styles.btn_leila : styles.btn}
                                            style={{
                                                background: searchButtonBackground,
                                                border: `1px solid ${site?.cor2 || '#FFFFFF'}`,
                                                color: searchButtonTextColor,
                                            }}
                                            >
                                            {site?.id != "1937" ? "Buscar" : "Fale com a Leila"}
                                        </Link>
                                    </div>
                                </div>
                            </motion.div>
                        : null }
                            <motion.div
                                alt="Avançado"
                                className={styles.buttonAdvanced}
                                initial={{ opacity: 0, y: 50 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{
                                    delay: 0.12,
                                    duration: 0.45,
                                    ease: "easeOut"
                                }}
                            >
                            {site?.id != "1937" && site?.id != "1999" ?
                                searchAdvanced ?
                                    <div onClick={() => setSearchAdvanced(0)}>
                                        <svg width="16" height="16" fill="white" viewBox="0 0 16 16">
                                            <path d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                                        </svg>
                                        <i style={{margin: "5px"}}>
                                            Simples
                                        </i>
                                    </div> :
                                    <div onClick={() => { trackMetaEvent(site, 'ViewContent', { content_name: 'Busca avançada', content_category: 'property_search' }); setSearchAdvanced(1); }}>
                                        <svg
                                            viewBox="0 0 18 18"
                                            height="1rem"
                                            width="1rem"
                                            aria-hidden="true"
                                            style={{ fill: 'white' }}
                                        >
                                            <path fill="none" d="M0 0h24v24H0V0z"></path>
                                            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
                                        </svg>
                                        <i style={{margin: "5px"}}>
                                            {Number(site?.id) === 2619 ? 'Busca avançada' : 'Avançado'}
                                        </i>

                                    </div>
                            : null}
                        </motion.div>
                    </div>

                    { allCards?.length > 0 ?
                        <motion.ul
                            alt="Busca rápida"
                            className={styles.allCards}
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{
                                delay: 0.1,
                                duration: 0.45,
                                ease: "easeOut"
                            }}
                        >
                            {allCards.map((card: any, index: number) => {
                                return (
                                    <li className={styles.allCardsLi} key={index}>
                                        <Link prefetch={false} href={removerAcentos(card?.url).toLowerCase()} passHref onClick={() => trackMetaEvent(site, 'ViewContent', { content_name: card?.nome, content_category: 'property_category_shortcut' })}>
                                            <div className={styles.card_busca} title={`Busca personalizada por imóvies: ${card?.nome}`}>{card?.nome}</div>
                                        </Link>
                                    </li>
                                );
                            })}
                        </motion.ul>
                    : null }
                </div>
            </div>
        </div>
    );
};

export default WelcomePieces;
